import type { default as HomeDepotRedirectJson } from "./HomeDepotRedirectInformation.api.json";

export type HomeDepotSettingsFormActions = undefined | "back" | "cancel" | "connect" | "disconnect";

type HomeDepotRedirectInfoResponseType = typeof HomeDepotRedirectJson;

export interface IHomeDepotSettingsFormValues {}

export class HomeDepotRedirectInfoResponse {
    constructor(data: HomeDepotRedirectInfoResponseType) {
        this.authorizationUrl = data.authorizationUrl;
    }
    authorizationUrl: string;
}

export class HomeDepotDisconnectResponse {}
